<link href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600&display=swap" rel="stylesheet">

<div class="fees-dashboard-wrapper">

  <div class="fees-page-header">
    <h2 class="fees-dashboard-title">Application fees dashboard</h2>
    <p class="fees-dashboard-sub">
      Track and manage all applicant payment transactions
      <span class="fees-total-badge">
        {{ allTransactionsCount }} total transactions
      </span>
    </p>
  </div>

  <!-- Error Banner -->
  <div class="fees-error-banner" *ngIf="errorMessage">
    <i class="ti ti-alert-circle"></i> {{ errorMessage }}
  </div>

  <!-- Summary Cards -->
  <div class="fees-summary-grid">
    <div class="fees-card fees-card-total"
         [class.fees-card-active]="activeTab === 'all'"
         (click)="filterTab('all')">
      <h4>TOTAL SIGNUPS</h4>
      <div class="fees-card-val">{{ loadingSummary ? '...' : totalSignups }}</div>
      <div class="fees-card-sub">{{ signupsWithNoTransaction }} no transaction yet</div>
    </div>

    <div class="fees-card fees-card-success"
         [class.fees-card-active]="activeTab === 'successful'"
         (click)="filterTab('successful')">
      <h4>SUCCESSFUL</h4>
      <div class="fees-card-val">{{ loadingSummary ? '...' : successfulPayments }}</div>
      <div class="fees-card-sub">Paid transactions</div>
    </div>

    <div class="fees-card fees-card-pending"
         [class.fees-card-active]="activeTab === 'pending'"
         (click)="filterTab('pending')">
      <h4>PENDING</h4>
      <div class="fees-card-val">{{ loadingSummary ? '...' : pendingPayments }}</div>
      <div class="fees-card-sub">Awaiting payment</div>
    </div>

    <div class="fees-card fees-card-failed"
         [class.fees-card-active]="activeTab === 'failed'"
         (click)="filterTab('failed')">
      <h4>FAILED</h4>
      <div class="fees-card-val">{{ loadingSummary ? '...' : failedPayments }}</div>
      <div class="fees-card-sub">Failed transactions</div>
    </div>
  </div>

  <!-- Tab Bar -->
  <div class="fees-tab-bar">
    <button [class.active]="activeTab === 'all'"        (click)="filterTab('all')">All transactions</button>
    <button [class.active]="activeTab === 'successful'" (click)="filterTab('successful')">Successful</button>
    <button [class.active]="activeTab === 'pending'"    (click)="filterTab('pending')">Pending</button>
    <button [class.active]="activeTab === 'failed'"     (click)="filterTab('failed')">Failed</button>
  </div>

  <!-- Toolbar -->
  <div class="fees-toolbar">
    <div class="fees-search-wrap">
      <i class="ti ti-search"></i>
      <input type="text"
             placeholder="Search name, email, phone..."
             [(ngModel)]="searchQuery"
             (input)="onSearch()" />
    </div>
    <div class="fees-count-info">
      Showing {{ pageStart }}–{{ pageEnd }} of {{ allTransactionsCount }} transactions
    </div>
  </div>

  <!-- Table Wrapper -->
  <div class="fees-table-wrapper">

    <!-- Loading -->
    <div class="fees-loading" *ngIf="loadingTable">
      <div class="fees-spinner"></div>
      <span>Loading transactions...</span>
    </div>

    <!-- Empty -->
    <div class="fees-empty" *ngIf="!loadingTable && filteredPayments.length === 0 && !errorMessage">
      <i class="ti ti-inbox"></i>
      <p>No transactions found</p>
    </div>

    <!-- Table -->
    <table class="fees-table" *ngIf="!loadingTable && filteredPayments.length > 0">
      <thead>
        <tr>
          <th class="col-name">Applicant</th>
          <th class="col-phone">Phone</th>
          <th class="col-chan">Channel</th>
          <th class="col-amt">Amount (₵)</th>
          <th class="col-type">Type</th>
          <th class="col-status">Status</th>
          <th class="col-date">Date</th>
          <th class="col-act">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let p of pagedPayments">
          <td>
            <div class="fees-name-cell">
              <div class="fees-avatar">{{ getInitials(p.signupFirstname, p.signupLastname) }}</div>
              <div class="fees-name-info">
                <div class="fees-name-main">{{ p.signupFirstname || '-' }} {{ p.signupLastname || '' }}</div>
                <div class="fees-name-email">{{ p.signupEmail || '-' }}</div>
              </div>
            </div>
          </td>
          <td>{{ p.customerPhoneNumber || '-' }}</td>
          <td>{{ p.channel || '-' }}</td>
          <td>₵ {{ p.amount | number:'1.2-2' }}</td>
          <td>{{ p.signupTypeofStudent || '-' }}</td>
          <td>
            <span [ngClass]="getStatusClass(p.status)">
              {{ getStatusLabel(p.status) }}
            </span>
          </td>
          <td>{{ p.createdAt | date:'dd MMM yyyy' }}</td>
          <td>
            <a [routerLink]="['/admin/application-fees/view', p.checkoutId]"
               class="fees-detail-link">View</a>
          </td>
        </tr>
      </tbody>

      <tfoot>
        <tr>
          <td colspan="3">TOTAL</td>
          <td class="col-amt">₵ {{ totalAmount | number:'1.2-2' }}</td>
          <td colspan="4"></td>
        </tr>
      </tfoot>
    </table>

    <!-- Pagination -->
    <div class="fees-pagination" *ngIf="!loadingTable && filteredPayments.length > 0">
      <div class="fees-pg-info">Page {{ currentPage }} of {{ totalPages }}</div>
      <div class="fees-pg-btns">
        <button class="fees-pg-btn" (click)="goPage(currentPage - 1)" [disabled]="currentPage === 1">
          <i class="ti ti-chevron-left"></i>
        </button>
        <ng-container *ngFor="let p of pageNumbers">
          <button class="fees-pg-btn"
                  [class.fees-pg-active]="p === currentPage"
                  (click)="goPage(p)">{{ p }}</button>
        </ng-container>
        <button class="fees-pg-btn" (click)="goPage(currentPage + 1)" [disabled]="currentPage === totalPages">
          <i class="ti ti-chevron-right"></i>
        </button>
      </div>
    </div>

  </div>
</div>